import React from 'react';

const ServicePackageDetails = ({ service, packageData }) => {
  return (
    <div className="bg-white border rounded-lg p-2 sm:p-3">
      <h3 className="text-sm sm:text-base font-bold text-black mb-2 sm:mb-3">Service & Package</h3>
      {service && (
        <div className="mb-2 sm:mb-3 pb-2 sm:pb-3 border-b-2 border-gray-300">
          <p className="text-xs text-gray-600 font-medium mb-0.5">Service</p>
          <p className="text-xs sm:text-sm font-medium text-black break-words">{service.service_name}</p>
          {service.service_category && (
            <p className="text-xs text-gray-600 mt-0.5 break-words">{service.service_category.category_name}</p>
          )}
        </div>
      )}
      {packageData && (
        <div>
          <p className="text-xs text-gray-600 font-medium mb-0.5">Package</p>
          <p className="text-xs sm:text-sm font-medium text-black mb-1 break-words">{packageData.package_name}</p>
          {packageData.description && (
            <p className="text-xs sm:text-sm text-gray-600 break-words">{packageData.description}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default ServicePackageDetails;

